// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAfVat1F6x74qzkRWyJ_b8nDsfj5swirJE",
  authDomain: "pack-tracker-39ecb.firebaseapp.com",
  projectId: "pack-tracker-39ecb",
  storageBucket: "pack-tracker-39ecb.firebasestorage.app",
  messagingSenderId: "526214386431",
  appId: "1:526214386431:web:ef3af872df3183d41a72ca"
};


const secondaryApp = getApps().find(a => a.name === 'Secondary')
  || initializeApp(firebaseConfig, 'Secondary'); // reuse your existing firebaseConfig object
export const secondaryAuth = getAuth(secondaryApp);

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Real "send now" for the Reconciliation page's reminder button: emails every
// currently-outstanding package's real recipients immediately and resets
// each of those packages' 14-day reminder timer. Admin/owner only — enforced
// server-side in functions/index.js regardless of what calls this.
export const sendOutstandingRemindersNow = () =>
  httpsCallable(functions, 'sendOutstandingPackageRemindersForceNow')();